// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button {
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
}

/* Variants */
.button.primary {
  background: #f97316;
  color: #fff;
  border: none;
  padding: 9px 22px;
}

.button.primary:hover {
  background: #ea580c;
}

.button.secondary {
  background-color: #fff;
  color: #374151;
  border: 1px solid #d1d5db;
  padding: 9px 22px;
}

.button.secondary:hover {
  background-color: #f9fafb;
  color: #374151;
  border: 1px solid #d1d5db;
}

.button.secondary .button-icon svg,
.button.secondary .button-icon svg path {
  fill: #374151 !important;
  stroke: #374151 !important;
}

.button.secondary:hover .button-icon svg,
.button.secondary:hover .button-icon svg path {
  fill: #374151 !important;
  stroke: #374151 !important;
}

.button.cancel {
  background-color: #6b7280;
  color: #fff;
  border: none;
  padding: 9px 22px;
}

.button.cancel:hover {
  background-color: #4b5563;
}

.button.cancel .button-icon svg,
.button.cancel .button-icon svg path {
  fill: #fff !important;
  stroke: #fff !important;
}

.button.ghost {
  background-color: transparent;
  color: #6b7280;
  border: none;
  padding: 0.375rem;
  border-radius: 8px;
}

.button.ghost:hover {
  background-color: #f3f4f6;
  color: #374151;
}

.button.danger {
  background-color: #ef4444;
  color: #fff;
  border: none;
  padding: 9px 22px;
}

.button.danger:hover {
  background-color: #dc2626;
}

.button.danger .button-icon svg,
.button.danger .button-icon svg path {
  fill: #fff !important;
  stroke: #fff !important;
}

/* Sizes */
.button.small {
  padding: 6px 14px;
  font-size: 13px;
}

.button.medium {
  padding: 9px 22px;
  font-size: 14px;
}

.button.large {
  padding: 12px 28px;
  font-size: 15px;
}

/* Disabled state */
.button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.button-icon svg {
  width: 20px;
  height: 20px;
}

.button-icon {
  margin-right: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/composants/Button/Button.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;;EAEE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA,UAAU;AACV;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB","sourcesContent":[".button {\r\n  border: none;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  transition: all 0.2s ease;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  align-self: stretch;\r\n}\r\n\r\n/* Variants */\r\n.button.primary {\r\n  background: #f97316;\r\n  color: #fff;\r\n  border: none;\r\n  padding: 9px 22px;\r\n}\r\n\r\n.button.primary:hover {\r\n  background: #ea580c;\r\n}\r\n\r\n.button.secondary {\r\n  background-color: #fff;\r\n  color: #374151;\r\n  border: 1px solid #d1d5db;\r\n  padding: 9px 22px;\r\n}\r\n\r\n.button.secondary:hover {\r\n  background-color: #f9fafb;\r\n  color: #374151;\r\n  border: 1px solid #d1d5db;\r\n}\r\n\r\n.button.secondary .button-icon svg,\r\n.button.secondary .button-icon svg path {\r\n  fill: #374151 !important;\r\n  stroke: #374151 !important;\r\n}\r\n\r\n.button.secondary:hover .button-icon svg,\r\n.button.secondary:hover .button-icon svg path {\r\n  fill: #374151 !important;\r\n  stroke: #374151 !important;\r\n}\r\n\r\n.button.cancel {\r\n  background-color: #6b7280;\r\n  color: #fff;\r\n  border: none;\r\n  padding: 9px 22px;\r\n}\r\n\r\n.button.cancel:hover {\r\n  background-color: #4b5563;\r\n}\r\n\r\n.button.cancel .button-icon svg,\r\n.button.cancel .button-icon svg path {\r\n  fill: #fff !important;\r\n  stroke: #fff !important;\r\n}\r\n\r\n.button.ghost {\r\n  background-color: transparent;\r\n  color: #6b7280;\r\n  border: none;\r\n  padding: 0.375rem;\r\n  border-radius: 8px;\r\n}\r\n\r\n.button.ghost:hover {\r\n  background-color: #f3f4f6;\r\n  color: #374151;\r\n}\r\n\r\n.button.danger {\r\n  background-color: #ef4444;\r\n  color: #fff;\r\n  border: none;\r\n  padding: 9px 22px;\r\n}\r\n\r\n.button.danger:hover {\r\n  background-color: #dc2626;\r\n}\r\n\r\n.button.danger .button-icon svg,\r\n.button.danger .button-icon svg path {\r\n  fill: #fff !important;\r\n  stroke: #fff !important;\r\n}\r\n\r\n/* Sizes */\r\n.button.small {\r\n  padding: 6px 14px;\r\n  font-size: 13px;\r\n}\r\n\r\n.button.medium {\r\n  padding: 9px 22px;\r\n  font-size: 14px;\r\n}\r\n\r\n.button.large {\r\n  padding: 12px 28px;\r\n  font-size: 15px;\r\n}\r\n\r\n/* Disabled state */\r\n.button:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.button-icon svg {\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n\r\n.button-icon {\r\n  margin-right: 0.5rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
